export default {
    app_name: 'MedMatch Network',

    microcopy: {
        add: 'Add',
        remove: 'Remove',
        next: 'Next',
        complete: 'Complete',
        close: 'Close',
        cancel: 'Cancel',
        confirm: 'Confirm',
        [true]: 'Yes',
        [false]: 'No',
        plus_x_more: '+{x} more',
        back_to_home: 'Back to homepage',
        to: 'to',
        start_typing: 'Start typing...',
        filters: 'FILTERS',
        update_list: 'Update List',
        reinvite: 'Re-invite',
        save: 'Save',
        done: 'Done',
        verify_insurance: 'Verify insurance',
        take_tour: 'TAKE A TOUR',
        exit: 'Exit',
        continue: 'Continue',
        send: 'Send',
        resend: 'Resend',
        back: 'Back',
        review: 'Review',
        review_send: 'Review & Send',
        add_more: '+ Add more',
        new: 'New',
        edit: 'Edit',
        accept: 'Accept',
        number_of: 'Number of',
        providers: 'providers',
        locations: 'locatons',
        selected: 'Selected',
        to_select_click: 'SELECT',
        no_results_found: 'No results found!',
    },

    users_list: {
        activate: 'Activate',
        switch_to: 'Switch to',
        new_referral: 'new referrals | new referral | new referrals',
        unavailable: 'This account has not been confirmed yet',
    },

    practice_type: {
        physician: 'Provider',
        ancillary: 'Ancillary',
        practice: 'Practice',
        company: 'Company',
        primary_care: 'Primary care',
    },

    referral_type: {
        direct: 'Direct',
        match: 'Match',
    },

    referral_details: {
        sent_to: 'Sent to',
        received_from: 'Received from',
        pcp: 'Primary care provider',
        show_pcp: 'Show primary care provider',
        patient_rating: 'Patient rating',
        view_chat: 'View entire conversation',
        send_message: 'Message Dr. {name}',
        send_message_ancillary: 'Message {name}',
        send_patient_message: 'Message patient: {name}',
        referral_note: 'Referral note:',
        notes: 'Notes:',
        consultation_report: 'Consultation report:',
        message_attachments: 'Message attachments',
    },

    referrals_overview: {
        title: 'Referrals overview',
    },

    pagination: {
        next: 'Show next',
        previous: 'Show previous',
    },

    images: {
        view: 'view',
        download: 'download',
        print: 'print',
    },

    upload: {
        unsupported: 'Unsupported file format',
    },

    phone_number: {
        placeholder: '1234567890',
    },

    order_by: {
        a_to_z: 'From A to Z',
        z_to_a: 'From Z to A',
        created_ascending: 'Created Ascending',
        created_descending: 'Created Descending',
    },

    navbar_item: {
        log_in: 'LOG IN',
        about_us: 'About Us',
        medmatch_network: 'MedMatch Network',
        contact_us: 'Contact Us',
        home: 'Home',
        enhance_referrals: 'Enhance Your Referrals For Free',
        start_free: 'Start Free!',
    },

    footer_item: {
        faq: 'FAQs',
        pricing_plans: 'Pricing Plans',
        help_desk: 'Help Desk',
        terms_conditions: 'Terms & Conditions',
        privacy_policy: 'Privacy Policy',
        report_a_bug: 'Report a Bug',
        enhance_your_referrals: 'Enhance Your Referrals For Free',
        platform_feedback: 'Platform Feedback',
        share_this_page: 'SHARE THIS PAGE',
        enhance_medical_referrals: 'Enhanced Medical Referrals',
        for_doctors_and_patients: 'for Doctors and Patients',
    },
    button: {
        enhance_referrals: 'Enhance Your Referrals For Free',
        learn_more: 'LEARN MORE',
    },

    specialities: {
        sub_specialities: 'SUB SPECIALTIES',
    },

    maps: {
        miles: 'Miles',
    },
    report_bug: {
        heading_main: 'Submit a Ticket for Support',
        heading_desc:
            "Our support team is here to help. Please provide detailed information about your issue and we'll get back to you as soon as possible.",
        title: 'Subject',
        title_placeholder: 'Brief summary of your issue',
        priority: 'Priority',
        pri_placeholder: 'Select priority level',
        issue: 'Issue Type',
        issue_placeholder: 'Select issue type',
        text: 'Support',
        support: 'Issue reported successfully',
        priority_hint: `Urgent: Service completely unavailable |
                        High: Significant impact on operations |
                        Normal: General inquiry or minor issue |
                        Low: Question or enhancement request`,
        upload_screenshot: 'Attachments (optional)',
        description_placeholder:
            'Please provide a detailed description of you issue or question. Include any relevant information that will heelp us assist you better',
        description_tip: "Tip: Include error messages, steps you've already tried, and what you expected to happen",
        attachments: 'Click to upload or drag and drop',
        attachments_text: 'Screenshots, error messages, or relevant images(PNG, JPG, GIF up to 10MB)',
    },
}
